import React from "react";

const Skeleton: React.FC<{ height?: string; width?: string }> = ({ height = "100%", width = "100%" }) => (
  <div
    style={{
      width,
      height,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: "linear-gradient(90deg, #f3f4f6 25%, #e0e7ef 37%, #f3f4f6 63%)",
      backgroundSize: "400% 100%",
      animation: "skeleton-loading 1.4s ease-in-out infinite",
      borderRadius: 12,
      minHeight: 120,
    }}
  >
    <style>
      {`
        @keyframes skeleton-loading {
          0% { background-position: 100% 50%; }
          100% { background-position: 0 50%; }
        }
      `}
    </style>
    {/* You can add subtle shapes for a chart or table look here if desired */}
  </div>
);

export default Skeleton;
